module.exports = __webpack_public_path__ + "static/media/cc1.203f9bf3.jpg";